import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useInView } from 'react-intersection-observer'

import { Layout, Header } from 'app/theme/layout'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'
import NavbarFixed from 'app/theme/NavbarFixed'
import ImageHero from 'app/theme/ImageHero'
import { OccasionPageGrid, OccasionPageGridRow } from './shared/OccasionPageGrid'
import CuisineTypes from 'app/theme/sections/CuisineTypes'
import HowItWorks from 'app/theme/sections/HowItWorks'
import HowItWorksLarge from 'app/theme/sections/HowItWorksLarge'
import WhyWorkWithUs from 'app/theme/sections/WhyWorkWithUs'
import FeaturedClients from 'app/theme/sections/FeaturedClients'
import OccasionsSlider from 'app/theme/sections/CateringOccasionsSlider'

import heroImg from 'assets/img/esports-page-hero.jpg'
import gridImage1 from 'assets/img/esports-page-grid-1.jpg'
import gridImage2 from 'assets/img/esports-page-grid-2.jpg'
import gridImage3 from 'assets/img/esports-page-grid-3.jpg'
import gridImage4 from 'assets/img/esports-page-grid-4.jpg'
import gridImage5 from 'assets/img/esports-page-grid-5.jpg'
import gridImage6 from 'assets/img/esports-page-grid-6.jpg'


export default function EsportsCateringPage() {
  const { openModal, ...modalState } = useModalState()

  const [ref, inView] = useInView({
    rootMargin: '1px',
    initialInView: true,
  })

  return (
    <Layout header={<Header occasionMenu />}>
      <Helmet>
        <title>Delicious Esports Concessions - Roaming Hunger</title>
        <meta name="og:title" content="Delicious Esports Concessions"></meta>
        <meta name="description" content="Delicious Esports Concessions"></meta>
      </Helmet>
      <LeadModal
        {...modalState}
      />
      <div ref={ref}>
        <ImageHero
          imageUrl={heroImg}
          title="Esports Food Concessions"
          onButtonClick={openModal}
          description={(
            <div>
              Feed the competitive spirit with esports concessionaires that fuel gamers
              and fans for days on end. The uninspiring arena hot dog and sluggish
              nachos are a thing of the past. Level up excitement with gourmet concessionaires
              at your esports Tournament.
            </div>
          )}
        />
      </div>
      {!inView && (
        <NavbarFixed
          onButtonClick={openModal}
        />
      )}
      <div className="container text-center py-12 px-8">
        <h2 className="text-navy text-4xl leading-tight font-platform">
          Data Driven Custom Event Concessions
        </h2>
        <p className="font-light text-gray-900 mt-6">
          With over 10 years of data from large and small events, we know what local audiences crave.
          We'll help you source and manage the right cuisine for your tournament, so you can keep
          fans happy and concessions profitable.
        </p>
      </div>

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="Variety"
          content="With over 16,000 vendors to choose from, we'll help you select the perfect mix to match your tournament theme and maximize concessionaire profits. Gourmet, thin crust pizza, lobster nachos, and Korean BBQ rice bowls are waiting. We won't forget the GFuel."
          image={gridImage1}
        />
        <OccasionPageGridRow
          heading="Theme Up"
          content="Use custom menus, branded serving wares, and cosplay wait staff to create an immersive food experience inside your arena. Looking to really blow it out? We'll develop a full-scale branded food truck promotion with all the bells and whistles."
          image={gridImage2}
          reverse
        />
        <OccasionPageGridRow
          heading="Upsell with souvenirs and collectibles at point of sale"
          content="Drive impulse sales by pairing meals with souvenirs and collectibles. We'll help increase average ticket size with custom character or player cups, figurines, and props."
          image={gridImage3}
        />
      </OccasionPageGrid>

      <WhyWorkWithUs
        onButtonClick={openModal}
      />

      <OccasionPageGrid className="bg-white py-8">
        <OccasionPageGridRow
          heading="Mana (energy) for the whole day"
          content="Keep the crowd excited through hours-long tournaments with food that will maintain energy and focus. Gourmet tacos and GameFuel slushees are always a fan favorite."
          image={gridImage4}
        />
        <OccasionPageGridRow
          heading="Quality is key"
          content="Break the stereotype and impress your audience with concessions that provide high quality and healthy food options. Pair an excellent meal with an interactive experience and you'll have them coming back year after year."
          image={gridImage5}
          reverse
        />
        <OccasionPageGridRow
          heading="Bring your sponsors into the mix"
          content="Leverage your immersive food experience to get sponsors excited about different branding opportunities. Sponsored beverage slushee stands or renaming menu items are organic ways to gain brand awareness."
          image={gridImage6}
        />
      </OccasionPageGrid>

      <CuisineTypes baseUrl='/food-truck-catering' />

      <HowItWorks
        heading="How Esport Catering Works"
        onButtonClick={openModal}
      />
      <HowItWorksLarge
        heading="How Esport Catering Works"
        onButtonClick={openModal}
      />

      <FeaturedClients
        onButtonClick={openModal}
      />

      <OccasionsSlider
        className="bg-white py-12"
      />

    </Layout>
  )
}
